module.exports = __webpack_public_path__ + "img/6.60bb3fc7.png";